module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/microsoft-sql-server.35528815.svg";